
//
const newsletterButtons = document.querySelectorAll('.newsletter-button');

//
const createElement = require('../utils/createElement.js');
const zenoFetch     = require('../utils/zenoFetch.js');
const debounce      = require('../utils/debounce.js');
const grecaptcha    = require('../utils/grecaptcha.js');

//
if (newsletterButtons != null) {

    //lets disable the buttons on the forms until the captcha is collected
    for (const newsletterButton of newsletterButtons) {

        //
        const newsletterButtonContent      = newsletterButton.querySelector('.newsletter-button-content');
        const newsletterButtonCallToAction = newsletterButton.querySelector('.newsletter-button-cta');
        const newsletterButtonForm         = newsletterButton.querySelector('.newsletter-button-form');
        const step2form                    = newsletterButton.querySelector('.step-2-form');
        const step1                        = newsletterButton.querySelector('.step-1');
        const step2                        = newsletterButton.querySelector('.step-2');

        //
        const buttonLoggedIn               = newsletterButton.querySelector('.newsletter-button-user-loggedin');

        //
        const validateEmail = (email) => {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        };

        //
        const displayUpdateNewsletterPreferencesResponse = (status, messages) => {

            //
            newsletterButtonForm.querySelector('button:not([type="button"])')?.removeAttribute('disabled');

            //
            newsletterButton.querySelectorAll('.form-status-message').forEach((statusMessageBlock) => {
                statusMessageBlock.remove();
            });

            if (buttonLoggedIn != undefined) {
                //check to see if the form (still) exists, if it does add the status message to it, else default to the component root
                const statusMessageTarget = buttonLoggedIn;
                const statusMessageBlock = createElement('div', { 'class' : 'form-status-message', 'data-status' : status });
                statusMessageTarget.append(statusMessageBlock);
            }

            //check to see if the form (still) exists, if it does add the status message to it, else default to the component root
            const statusMessageTarget = ((newsletterButton.querySelector('.newsletter-button-form') !== null) ? newsletterButtonForm : newsletterButton);

            //
            const statusMessageBlock = createElement('div', { 'class' : 'form-status-message', 'data-status' : status });
            statusMessageTarget.append(statusMessageBlock);

            //
            if (status === 'error') {
                messages.forEach((message) => {
                    statusMessageBlock.append(createElement('div', {}, message));
                });
            } else {
                statusMessageBlock.innerHTML = newsletterButton.dataset.successMessage;
            }

        }

        //
        const updateNewsletterPreferences = async (payload) => {

            //
            const [status, messages] = await zenoFetch('post', '/api/update-newsletter-preferences', {}, { ...(payload || {}), 'subscriptions' : newsletterButton.dataset.subscriptions });

            //
            if (status == 'success') {

                if (step2form) {
                    step2form.innerHTML = '';
                } else if (buttonLoggedIn) {
                    buttonLoggedIn.innerHTML = '';
                } else {
                    newsletterButton.innerHTML = '';
                }
            }

            //
            if (newsletterButtonForm !== null && status == 'error') {
                window.grecaptcha.reset(grecaptchaWidget);
            }

            //
            displayUpdateNewsletterPreferencesResponse(status, messages);

        }

        //if the form is missing, we can assume a member is authenticated, so send the submission and let the server deal with it
        if (newsletterButtonForm === null) {

            //
            newsletterButtonCallToAction.addEventListener('click', debounce(200, function(event) {
                updateNewsletterPreferences({});
            }));

            //
            continue;

        }

        //toggle the display of the button and form
        newsletterButtonCallToAction.addEventListener('click', debounce(200, function(event) {

            //
            const emailValue = newsletterButtonForm.querySelector('input[name="email"]').value.trim();

            //validate email before proceeding
            if (!validateEmail(emailValue)) {

                //
                const fieldErrorMessage = createElement('div', { 'class' : 'input-error-message', 'data-status' : 'error' });
                fieldErrorMessage.innerHTML = 'Please enter a valid email address';

                //
                const inputGroup = newsletterButtonForm.querySelector('.step-1 .input-group');

                if (inputGroup) {

                    //clear any existing error messages
                    const existingErrorMessage = inputGroup.querySelector('.input-error-message');
                    if (existingErrorMessage) {
                        existingErrorMessage.remove();
                    }

                    //append the error message to the input group
                    inputGroup.append(fieldErrorMessage);
                    return;

                }

            }

            //set the text of the span with data-name="emailAddress"
            const emailAddressSpan = newsletterButton.querySelector('span[data-name="emailAddress"]');

            if (emailAddressSpan) {
                emailAddressSpan.textContent = emailValue;
            }

            //
            newsletterButtonCallToAction.style.display = 'none';
            newsletterButtonForm.style.display = 'flex';
            step1.style.display = 'none';
            step2.style.display = 'block';

        }));

        //disable the submit button, this can be reenabled once the recaptcha has been completed
        newsletterButtonForm.querySelector('button:not([type="button"])').setAttribute('disabled', 'disabled');
        const grecaptchaWidget = grecaptcha(newsletterButtonForm.querySelector('input[name="grecaptcha"]'), () => {
            newsletterButtonForm.querySelector('button:not([type="button"])').removeAttribute('disabled');
        })

        //
        newsletterButtonForm.addEventListener('submit', function(event) {
            event.preventDefault(); event.stopPropagation();
        });

        //
        newsletterButtonForm.addEventListener('submit', debounce(200, function(event) {

            //
            const newsletterButtonFormData = new FormData(newsletterButtonForm);

            //get the values of firstname and surname
            const firstname = newsletterButtonFormData.get('firstname').trim();
            const surname = newsletterButtonFormData.get('surname').trim();

            //check if firstname or surname is empty
            if (!firstname || !surname) {
                //create the error message element
                const fieldErrorMessage = createElement('div', { 'class': 'input-error-message', 'data-status': 'error' });
                fieldErrorMessage.innerHTML = 'Please enter both first name and last name.';

                //
                const fieldsContainer = newsletterButtonForm.querySelector('.fieldsContainer');

                //check if .fieldsContainer exists and insert the error message after it
                if (fieldsContainer) {
                    fieldsContainer.insertAdjacentElement('afterend', fieldErrorMessage);
                    return; //stop the form submission if validation fails
                }

            }

            //disable the button while we wait for the response
            newsletterButtonForm.querySelector('button:not([type="button"])').setAttribute('disabled', 'disabled');

            //
            updateNewsletterPreferences({
                'formSent'    : newsletterButtonFormData.get('formSent'),
                'formToken'   : newsletterButtonFormData.get('formToken'),
                'formCaptcha' : newsletterButtonFormData.get('grecaptcha'),
                'firstname'   : newsletterButtonFormData.get('firstname'),
                'surname'     : newsletterButtonFormData.get('surname'),
                'email'       : newsletterButtonFormData.get('email'),
            });
        }));

    }

}
